module.exports = __webpack_public_path__ + "static/media/close-btn-white.c531e43a.svg";